export enum ProfileSetupStepType {
  BankAccount = 'BankAccount',
  DriversLicense = 'DriversLicense',
  ProfessionalLicense = 'ProfessionalLicense',
  I9Form = 'I9Form',
  BackgroundCheck = 'BackgroundCheck',
  ImmunizationRecords = 'ImmunizationRecords'
}
